import { createContext, MutableRefObject, ReactNode, useRef } from "react";
import { appConfig } from "../../constants";
import { cloneDeep } from "lodash";
const { retainTabRoutesWithInfiniteScroll } = appConfig;

export interface IScrollInfoData {
  isBack: boolean;
  page: number;
}

export interface IScrollInfo {
  [key: string]: IScrollInfoData;
}

const initialScollInfoData = {
  isBack: false,
  page: 1,
};

// const initialScrollInfo: IScrollInfo = {
//   all: {
//     isBack: false,
//     page: 1,
//   },
//   activity: {
//     isBack: false,
//     page: 1,
//   },
// };

let initialScrollInfo = retainTabRoutesWithInfiniteScroll.reduce(
  (initialScrollInfo, routePath) => {
    initialScrollInfo[routePath as string] = { ...initialScollInfoData };
    return initialScrollInfo;
  },
  {} as IScrollInfo
);

initialScrollInfo = {
  ...initialScrollInfo,
  "/activity/[userId]": {
    isBack: false,
    page: 1,
  },
  "/joined-clubhouses/all": {
    isBack: false,
    page: 0,
  },
  "/joined-clubhouses/handpicked": {
    isBack: false,
    page: 0,
  },
  "/joined-clubhouses/bookmarked": {
    isBack: false,
    page: 0,
  },
  "/joined-clubhouses/clubhouse/[chId]/all": {
    isBack: false,
    page: 0,
  },
  "/joined-clubhouses/clubhouse/[chId]/handpicked": {
    isBack: false,
    page: 0,
  },
  "/joined-clubhouses/clubhouse/[chId]/huddles": {
    isBack: false,
    page: 0,
  },
  "/joined-clubhouses/clubhouse/[chId]/bookmarked": {
    isBack: false,
    page: 0,
  },
  "/join-clubhouses": {
    isBack: false,
    page: 0,
  },
};

interface IScrollContext {
  scrollInfoRef: MutableRefObject<IScrollInfo>;
  resetScrollInfo: () => void;
}

export const ScrollContext = createContext({} as IScrollContext);

interface IScrollContextProvider {
  children: ReactNode;
}

//INFO: It basically stores the current page on scroll for infinitely loading page - once user clicks back respective feed page/or any other page with infinite scroll will this page number gets restored in the state
export const ScrollContextProvider = ({ children }: IScrollContextProvider) => {
  const scrollInfoRef = useRef<IScrollInfo>(cloneDeep(initialScrollInfo));
  const resetScrollInfo = () => {
    scrollInfoRef.current = cloneDeep(initialScrollInfo);
  };

  return (
    <ScrollContext.Provider value={{ scrollInfoRef, resetScrollInfo }}>
      {children}
    </ScrollContext.Provider>
  );
};
